import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, lineHeights, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const streamSelectionTagGroupContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s14,
  marginBottom: space.s6,
});

export const streamSelectionTagGroup = style([
  responsiveStyle({
    mobile: {
      flexDirection: 'column',
      gap: space.s8,
    },
    tablet: {
      flexDirection: 'row',
      gap: space.s14,
    },
  }),
]);

export const streamSelectionTagGroupItem = style([
  typography.bodyMd,
  {
    borderRadius: borderRadius.r12,
    padding: `${space.s12}px ${space.s14}px`,
    display: 'flex',
    justifyContent: 'start',
    height: '100%',

    selectors: {
      '&[data-state=on]': {
        border: `1px solid ${themeVars.color.border.brand}`,
      },
    },
  },
  responsiveStyle({
    mobile: {
      flexBasis: '100%',
      width: '100%',
    },
    tablet: {
      flexBasis: '50%',
      width: 'auto',
    },
  }),
]);

export const selectionTagGroupItemContent = style([
  {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'start',
    gap: space.s8,
  },
]);

export const selectionTitleContainer = style([
  typography.titleMd,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
  },
]);

export const selectionDescription = style([
  {
    lineHeight: lineHeights.normal,
  },
]);
